import { Booking } from '@/types';
import { getNzDateTimeParts } from '@/utils/nzDate';

export const hasBookingEndedNz = (booking: Pick<Booking, 'date' | 'end_time'>) => {
  if (!booking?.date || !booking?.end_time) return false;
  const { date: nowDate, time: nowTime } = getNzDateTimeParts();
  if (booking.date < nowDate) return true;
  if (booking.date > nowDate) return false;
  return booking.end_time <= nowTime;
};

export const isBookingExpired = (booking: Booking) => {
  return (
    (booking.status === 'pending' || booking.status === 'confirmed') &&
    hasBookingEndedNz(booking)
  );
};

// Staff UI needs a dedicated "expired" bucket for bookings that ended but were not processed.
// This is a display-only status and is computed from time + DB status.
export const getBookingEffectiveStatus = (booking: Booking): Booking['status'] => {
  if (isBookingExpired(booking)) return 'expired';
  return booking.status;
};
